import React, { useState } from 'react'
import { Tabs, Tab, useTheme } from '@material-ui/core'
import { Container, TabPanel } from '../../../components'
import { ApplicationsTab } from './ApplicationsTab'
import { CompaniesAccessTab } from './CompaniesAccessTab'

const APPLICATIONS_TAB = 0
const COMPANIES_TAB = 1

export const ApplicationAccessHome = () => {
    const theme = useTheme()
    const [selectedTab, setSelectedTab] = useState<number>(APPLICATIONS_TAB)

    const tabPanelStyle: React.CSSProperties = {
        backgroundColor: theme.palette.grey[200],
        flex: 1,
    }

    return (
        <Container style={{ flex: 1, flexDirection: 'column' }} scrollY>
            <Tabs
                value={selectedTab}
                onChange={(_, newValue) => setSelectedTab(newValue)}
                style={{ backgroundColor: theme.palette.grey[300] }}
            >
                <Tab label="Applications" value={APPLICATIONS_TAB} />
                <Tab label="Company Access" value={COMPANIES_TAB} />
            </Tabs>

            <TabPanel
                value={APPLICATIONS_TAB}
                index={selectedTab}
                style={tabPanelStyle}
            >
                <ApplicationsTab />
            </TabPanel>

            <TabPanel
                value={COMPANIES_TAB}
                index={selectedTab}
                style={tabPanelStyle}
            >
                <CompaniesAccessTab />
            </TabPanel>
        </Container>
    )
}
